__webpack_public_path__ = window.remoteUrl;

require('optimize-suite/build/optimize-suite');

const { documentReady, windowLoaded } = require('@grpn/document-states');

const { Optimize } = window;
const { config } = Optimize.suiteData;
config.finch = { config: Optimize.finchConfig };
Optimize.config = config;
OptimizeSuite.init(config);

documentReady.then(() => {
  if (!Optimize.delayBloodhound) {
    OptimizeSuite.initBloodhound();
  }
});

windowLoaded.then(() =>
  setTimeout(() => {
    if (Optimize.delayBloodhound) {
      OptimizeSuite.initBloodhound();
    }
  }, 0)
);

if (config.devMode) {
  // FIXME: this should be moved into the optimizeInspector. The new styles are necessary with the new GIG v8
  const style = document.createElement('style');
  style.innerText = `#optimize-inspectors-menu input{-webkit-appearance: checkbox;appearance:checkbox;visibility:visible;height:15px;width:15px}`;
  document.head.appendChild(style);

  import('optimize-suite/build/optimize-suite-lazyloaded').then(module => {
    window.OptimizeSuite.initLazyLoaded(config);
  });
}
